import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Overlay from '../Miscelania/Overlay';

import Toggle from 'react-toggle';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import {ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';


class AircraftLogbooksSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      data: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.search = this.search.bind(this);
    this.exportPdf = this.exportPdf.bind(this);
    this.exportXls = this.exportXls.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.AlertColumn = this.AlertColumn.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleSelectChangeMultiple(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/papeleta/consulta/gestor/dados', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            staffs_select: responseJson.data,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }


  search(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');

    var datasave = {
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      staffs: this.state.staffs,
      fired: this.state.fired,
      alerts: this.state.alerts,
    };

    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/papeleta/consulta/gestor/pesquisa', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
          self.handleAlert('', '', 'closed');
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  exportPdf(url) {
    var self = this;
    var header = this.refs.request_api.header('application/json');

    var datasave = {
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      staffs: this.state.staffs,
      fired: this.state.fired,
      alerts: this.state.alerts,
    };

    self.handleAlert('Aguarde enquanto o arquivo é gerado. Este processo pode levar alguns minutos.', 'warning', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/papeleta/consulta/gestor/pdf', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          var url = config.get('cdn') + '/tmp/' + responseJson.data;
          self.setState({
            url_export: url,
          });
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
        }
      });
    });
  }


  exportXls(url) {
    var self = this;
    var header = this.refs.request_api.header('application/json');

    var datasave = {
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      staffs: this.state.staffs,
      fired: this.state.fired,
      alerts: this.state.alerts,
    };

    self.handleAlert('Aguarde enquanto o arquivo é gerado. Este processo pode levar alguns minutos.', 'warning', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/papeleta/consulta/gestor/xls', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          var url = config.get('cdn') + '/tmp/' + responseJson.data;
          self.setState({
            url_export: url,
          });
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
        }
      });
    });
  }

  ActionsButtons (cell, row) {
    var url = '/papeleta/editar/' + cell;

    var botao = (
      <div className="btn-group">
        <Link className={'btn btn-primary btn-sm'} to={url}>
          <i className="fa fa-fw fa-pencil"></i>
        </Link>
      </div>
    );

    return botao;
  }


  AlertColumn (cell, row) {

    if (cell === 'Sim') {
      var botao = (
        <span className="label label-danger" style={{ fontSize: 14 }}>
          Sim
        </span>
      );
    } else {
      var botao = (
        <span className="label label-success" style={{ fontSize: 14 }}>
          Não
        </span>
      );
    }

    return botao;
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">Consulta de Diários de Bordo</h3>
      <hr/>

      <form onSubmit={this.search}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>Data Inicial:</label>
            <InputMask value={this.state.date_start}  maskChar={null} name="date_start " mask="99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="mm/yyyyy" required />
          </div>
          <div className="col-md-6 form-group">
            <label>Data Final:</label>
            <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish " mask="99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="mm/yyyyy" required />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 form-group">
            <label>Aeronaves:</label>
            <Select
              className=""
              name="aircrafts"
              value={this.state.aircrafts}
              searchable={true}
              placeholder={''}
              multi={true}
              // onChange={this.handleSelectChangeMultiple.bind(this, 'aircrafts')}
              options={[
                {label: 'PR-OHN', value: 1},
                {label: 'PR-OHA', value: 2},
                {label: 'PR-OHB', value: 3},
                {label: 'PR-OHC', value: 4},
              ]}
            />
          </div>
          <div className="col-md-4 form-group">
            <label>Status:</label>
            <Select
              className=""
              name="status"
              value=""
              searchable={true}
              placeholder={''}
              // onChange={this.handleSelectChange.bind(this, 'fired')}
              options={[
                {label: 'Rascunho', value: 1},
                {label: 'Finalizado', value: 2},
                {label: 'Aprovado', value: 3},
                {label: 'Enviado para ANAC', value: 4},
                {label: 'Cancelado', value: 0},
              ]}
            />
          </div>
          <div className="col-md-4 form-group">
            <label>Somente com alertas:</label>
            <Select
              className=""
              name="alerts"
              value={this.state.alerts}
              searchable={true}
              placeholder={''}
              onChange={this.handleSelectChange.bind(this, 'alerts')}
              options={[
                {label: 'Sim', value: 1},
                {label: 'Não', value: 0}
              ]}
            />
          </div>
        </div>
        <hr/>
        <button type="submit" className="btn btn-primary btn-block btn-lg"><i className="fa fa-fw fa-search"></i> Pesquisar</button>
      </form>
      <hr/>
      <div className="row">
        <div className="col-md-6 form-group">
          <button onClick={() => {this.exportPdf()}} className="btn btn-success btn-block btn-lg"><i className="fa fa-fw fa-file-pdf-o"></i> Exportar PDF</button>
        </div>
        <div className="col-md-6 form-group">
          <button onClick={() => {this.exportXls()}} className="btn btn-warning btn-block btn-lg"><i className="fa fa-fw fa-file-excel-o"></i> Exportar XLS</button>
        </div>
      </div>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} options={{exportCSVText: 'Exportar CSV', noDataText: ' '}} multiColumnSearch={true}  searchPlaceholder='Procurar'>
        <TableHeaderColumn dataField="staff_name" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}}>Tripulante</TableHeaderColumn>
        <TableHeaderColumn dataField="month" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}}>Mês/Ano</TableHeaderColumn>
        <TableHeaderColumn dataField="alerts" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} dataFormat={this.AlertColumn}>Alertas</TableHeaderColumn>
        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>Ações</TableHeaderColumn>
      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default AircraftLogbooksSearch;


// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/AircraftLogbooksSearch.js